<template>
<div>
  <v-tooltip
    bottom>
    <template
      v-slot:activator="{ on, attrs }">

      <v-chip
        v-bind="attrs"
        v-on="on"
        small
        color="primary"
        @click="onDialogButtonClick"
      >
        紐づけ配車表選択
      </v-chip>

    </template>

    <!-- RAW形式で文字列展開 -->
    <span v-html="message"></span>

    <dd-himoduke-haishahyo-search-dialog
      :showDialog="showDialog"
      ref="haishahyoDialog"
      @close="onDialogClosed"/>
  </v-tooltip>
</div>
</template>
<script>
const DdHimodukeHaishahyoSearchDialog = () => import('@/components/DdHimodukeHaishahyoSearchDialog')

export default {
  name: 'DdHimodukeHaishahyoAddButton',
  components: {
    DdHimodukeHaishahyoSearchDialog
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    item: {
      type: Array
    }
  },
  data: () => ({
    innerValue: '',
    showDialog: false
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
        // readonly: this.readonly
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isHelpDisplay () {
      return this.readonly === false
    }
  },
  methods: {
    onDialogButtonClick: function (e) {
      this.$refs.haishahyoDialog.fetchData(this.item)
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      console.log('dialog closed', e, this.showDialog)
      this.showDialog = false
      if (e === undefined) { return }
      this.himodukeHaishahyoAddSync(e)
      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       * this.$emit('input', this.innerValue)
       */
    },
    himodukeHaishahyoAddSync: function (e) {
      console.log(' **** XXXXX **** himodukeHaishahyoAddSync', e, this.showDialog)
      this.$emit('himodukeHaishahyoAddSync', e)
    }
  }
}
</script>
<style scoped>

</style>
